import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import moment from "moment";
import { SectorAutomationScreen } from "../../screen/SectorAutomationScreen";
import { useScope, useUser } from "../SelectProjectCompanyContainer";
import { customToast } from "../../components/Toast";
import Send from "../../core/communication";
import { useFormProject } from "../../core/utils/hooks/useFormProject";
import { useNavigate } from "react-router-dom"
import { useAssistanceResolve } from "../../core/utils/hooks/useAssistanceResolve";

export const SectorAutomationContainer = ({ selectedsUsers, sectorModalIsOpen, setSectorModalIsOpen, pinnedMessages, isChatContainer }) => {
  const tags = useSelector(state => state.app.tags) || [];
  const { scope, scopeType } = useScope();
  const user = useUser()
  const navigate = useNavigate()

  const projectId = isChatContainer ? selectedsUsers[0]?.projectId : scope?.id;
  const projectType = isChatContainer ? "project" : scopeType;
  const { forms: formsByProject } = useFormProject(projectId, projectType);
  
  const { setReload } = useAssistanceResolve()
  const [projectList, setProjectList] = useState([]);
  const [uniqueAssistance, setUniqueAssistance] = useState(true);
  const [formOptions, setFormOptions] = useState([]);
  const [usersTec, setUsersTec] = useState([]);
  const [loading, setLoading] = useState(false);
  const [execNow, setExecNow] = useState(false);
  const [redirectToAssistance, setRedirectToAssistance] = useState(false);
  const [values, setValues] = useState({ hasContentAssistance: { value: '1', label: 'Sim' } });
  const [projectTags, setProjectTags] = useState([]);
  const [isTec, setIsTec] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    getValues
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    if(sectorModalIsOpen) {
      getTagsByProject();
      setValue('dateToAdd', moment().format('YYYY-MM-DD'));
      
      if(isChatContainer) {
        const newProjectList = selectedsUsers[0]?.projectIds;
        setProjectList([...new Set(newProjectList)]);
        console.log("NEW PROJECT LIST -> ", newProjectList)
      } else {
        setProjectList([...new Set(selectedsUsers.map(row => row?.projectId))]);
      }
    }

    return () => setProjectTags([]);
  }, [sectorModalIsOpen]);

  useEffect(() => {
    if(projectList && projectList.length) {
      loadTec(projectList);
    }
  }, [projectList]);

  useEffect(() => {
    if(formsByProject && Array.isArray(formsByProject)) {
      const newFormOptions = formsByProject.map(form => ({ label: form?.title, value: form?.id }));
      setFormOptions(newFormOptions)
      setValues({...values, forms: newFormOptions.filter(form => 
        form.value === '77823afb-d96f-43d5-b895-bf32ad055899' ||
        form.value === '5b7c11b3-9ea1-4d70-8dc4-cbfff6f8706b'
      )})
    }

    return () => setFormOptions([]);
  }, [formsByProject])

  useEffect(() => {
    if(user?.id === getValues()?.technician) {
      setIsTec(true)
    } else {
      setIsTec(false)
      setRedirectToAssistance(false)
    }
  }, [user, getValues()?.technician])

  useEffect(() => {
    if (execNow && isTec) {
      setRedirectToAssistance(true)
    } else {
      setRedirectToAssistance(false)
    }
  }, [execNow, isTec])

  const getTagsByProject = () => {
    const tagsProjects = tags?.filter(item => item?.projectId === scope?.id || item.projectId === '');
    setProjectTags(tagsProjects)
  }

  const handleChangeInput = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const handleCloseModal = () => {
    setSectorModalIsOpen(false);
    
    setExecNow(false)
  }

  const handleSetExecNow = () => {
    if(!execNow) {
      setValue('dateToAdd', moment().format('YYYY-MM-DD'));

      if(getValues()['dateToRemove']) {
        setValue('dateToRemove', moment().format('YYYY-MM-DD'));
      }
      setRedirectToAssistance(false)
    }
    setExecNow(!execNow);
  }

  const handleSave = async (formValues) => {

    const formattedData = {
      ...formValues,
      ...values,
      dateToRemove: formValues.dateToRemove || null,
      tagsToAdd: JSON.stringify(formValues.tagsToAdd.map(tag => tag.value)),
      tagsToRemove: formValues.tagsToRemove ? JSON.stringify(formValues.tagsToRemove.map(tag => tag.value)) : '[]',
      userId: user?.id,
      isExecNow: execNow,
      uniqueAssistance: uniqueAssistance ? '1' : '0'
    };

    if(!formattedData.forms || !formattedData.forms.length) {
      customToast('Você deve escolher o(s) formulário(s)', 'error');
      return;
    }

    try {
      setLoading(true);
  
      for await (const projectId of projectList) {
        const usersToCreate = selectedsUsers.filter(row => row?.projectId === projectId);

        const response = await Send.post('/events-sector', {
          ...formattedData,
          projectId,
          userIds: JSON.stringify(usersToCreate.map(user => user.id)),
        });
        
        if(response.status === 'error') {
          throw new Error(response.status);
        }

        if(projectList?.length === 1 && response?.data && redirectToAssistance){
          navigate("/assistance/resolve", {state: { dataResolve: response?.data}})
          setReload(true)
        }

        customToast(`Evento criado para o projeto "${usersToCreate[0]?.project}"`, 'success');
      }

      handleCloseModal();
    } catch (error) {
      customToast('Erro ao salvar automação.', 'error');
    }

    setLoading(false);
  }

  const loadTec = async (projectList) => {
    try {
      const tec = await Send.get(`/users/tec-or-manager`, `projects=${projectList.map(row => `'${row}'`).join(',')}&scopeType=project`);
      
      if(tec && tec.length){
        setUsersTec(tec.map((user) => ({ label: `${user?.name} - ${user?.email}`, value: user?.id })));
      }
    } catch(error) {
      console.log("Error", error)
      customToast('Erro ao buscar técnicos do projeto.', 'error');
      setUsersTec([]);
    }
  }

  return <SectorAutomationScreen
    {...{
      selectedsUsers,
      loading,
      handleCloseModal,
      modalIsOpen: sectorModalIsOpen,
      register,
      projectTags,
      handleChangeInput,
      values,
      handleSubmit: handleSubmit(handleSave),
      errors,
      control,
      watch,
      usersTec,
      isTec,
      formOptions,
      handleSetExecNow,
      setRedirectToAssistance,
      redirectToAssistance,
      execNow,
      uniqueAssistance,
      setUniqueAssistance,
      pinnedMessages
    }}
  />
}